import { saveLoginInfo } from '@/utils'
import { handleFinalJump, handleScheme } from '@/utils/login.js'
import { handleLogin } from '@/utils/mutiple.js'
import { getBusinessType } from '@/constant'
import { getItem } from '@/utils/storage-main.js'
import store from '@/store'
import api from '@/http/api.js'
import { Message } from 'element-ui'

// 保存auth信息并执行跳转操作
const handleSaveAndJump = async (data) => {
  try {
    const { token, expires_in, refresh_token,sso_resp } = data
    saveLoginInfo({ token, expires_in, refresh_token, sso_resp })
    // 获取用户的信息
    if (getBusinessType()?.selfLogin && !['cim', 'nissan'].includes(localStorage.getItem('business'))) {
      await store.dispatch('CheckProtocal')
      await store.dispatch('getUserInfo')
      handleFinalJump()
    } else {
      handleLogin(getItem('business'))
    }
  } catch (error) {
    handleScheme(error)
  }
}
export const handleSaveAndJumpWithMemberCard = async (data) => {
  return new Promise(async (resolve, reject) => {

    try {
      const { token, expires_in, refresh_token,sso_resp } = data
      saveLoginInfo({ token, expires_in, refresh_token, sso_resp })
      const res = await api.user.postInMemberCard({ act: 'card', source: 'aiahrn' })
      if(!res.data.code) {
        reject()
        return Message.error('非受邀用户账户，暂无法登录。请检查账户或联系HR。')
      }
      
      // 获取用户的信息
      if (getBusinessType()?.selfLogin && localStorage.getItem('business') !== 'cim') {
        await store.dispatch('CheckProtocal')
        await store.dispatch('getUserInfo')
        handleFinalJump()
      } else {
        handleLogin(getItem('business'))
      }
      resolve()
    } catch (error) {
      reject()
      handleScheme(error)
    }
  })
}



export default handleSaveAndJump 